import ContactApi from 'api/contacts';
import { persistCustomFields } from 'api/third';
import { v4 as uuidv4 } from 'uuid';
import { checkNotBlank } from 'vcomponents/forms/rules/Rules'
import Third from 'stores/forms/third';
import { _ } from 'core-js';


const rules = {
    name: [
        { required: true, message: window.i18n.__('Veuillez renseigner un nom'), trigger: 'blur' },
        { validator: checkNotBlank, trigger: 'submit' },
    ],
    email: [
        { required: false, type: 'email', message: window.i18n.__('Veuillez renseigner une adresse email'), trigger: 'blur' },
    ]
};

const contactState = () => {
    return {
        civility: null,
        name: '',
        forename: '',
        role: null,
        birthdate: null,
        email: null,
        type: "contact",
        contactNumber:{
            phoneNumber: null,
            mobileNumber:null,
            faxNumber:null,
        },
        paramsSettings: {
            syncProviders:{
                mailchimp : {name: "mailchimp", isSetup: false},
                mailjet : {name: "mailjet", isSetup: false},
                simplemail : {name: "simplemail", isSetup: false},
            },
            social: {
                facebook: null,
                linkedin: null,
                twitter: null
            },
            marketing: [
                {label: window.i18n.__("SMS"), value: false, code: "textmsg"},
                {label: window.i18n.__("Téléphonique"), value: false, code: "phone"},
                {label: window.i18n.__("Email"), value: false, code: "email"},
                {label: window.i18n.__("Courrier"), value: false, code: "mail"},
                {label: window.i18n.__("Marketing personnalisé"), value: false, code: "custom"}
            ],
            note: '',
        },
        smartTagsType: "people",
        smartTags: [],
        isLinkedContact: false
    }
};

export default {
    namespaced: true,
    state() {
        return {
            ...Third.state(),
            company: {},
            listing: {
                contactsList : []
            },
            syncProvidersList: [],
            rules: rules,
            civilities: [],
            id: null,
            contact: contactState(),
            listings: {
                types : ["contact"]
            },
            sideParams: {
                rateCategories: false,
                note: true,
                social: true,
                smarttags: true,
                marketing: true,
                syncProviders: true
            }
        }
    },
    getters: {
        ...Third.getters,
        civilities: state => {
            return state.civilities;
        },
        civility: state => {
            return state.contact.civility;
        },
        name: state => {
            return state.contact.name;
        },
        forename: state => {
            return state.contact.forename;
        },
        role: state => {
            return state.contact.role;
        },
        birthdate: state => {
            return state.contact.birthdate;
        },
        email: state => {
            return state.contact.email;
        },
        getType: (state) =>{
            return state.contact.type;
        },
        getPhone: (state) =>{
            return state.contact.contactNumber.phoneNumber;
        },
        getMobile: (state) =>{
            return state.contact.contactNumber.mobileNumber;
        },
        getFax: (state) =>{
            return state.contact.contactNumber.faxNumber;
        },
        getSocial: state => {
            return state.contact.paramsSettings.social;
        },
        getFacebook: (state) => {
            return state.contact.paramsSettings.social.facebook
        },
        getTwitter: (state) => {
            return state.contact.paramsSettings.social.twitter
        },
        getLinkedin: (state) => {
            return  state.contact.paramsSettings.social.linkedin
        },
        getModel: (state, getters) => {
            return {
                ...state.third,
                ...state.contact,
                groupedCustomFields: getters.groupedCustomFields
            }
        },
        getState: state=>{
            return {contact: {...state.contact}, id: state.id}
        },
        getRules: state => {
            return state.rules;
        },
        smartTags: state => {
            let tags = [];
            if(state.contact.smartTags.length > 0){
                tags = state.contact.smartTags.map(tag => { 
                    let id = (!_.isNil(tag.id) ? parseInt(tag.id) : null)
                    return {...tag, id: id }
                });
            }
            return tags
        },
        getSmartTagsType: state => {
            return state.contact.smartTagsType;
        },
        getNote: (state) => {
            return state.contact.paramsSettings.note;
        },
        getSyncProviders: (state) =>{
            let syncs = [];
            Object.entries(state.contact.paramsSettings.syncProviders).forEach(([key, value]) =>{
                syncs[key] = value
            })
            return syncs;
        },
        getSyncProvidersList: (state) => {
            return state.syncProvidersList;
        },
        getMarketing: (state) => {
            return state.contact.paramsSettings.marketing;
        },
        getParamsConfig: (state, getters) => {
            return {
                ...state.sideParams,
            }
        },
        getContactsList: (state)=> {
            return state.listing.contactsList;
        },
        getIsLinkedContact: (state)=> {
            return state.contact.isLinkedContact;
        }
    },
    mutations: {
        ...Third.mutations,
        setForm: (state, payload) =>{
            state.contact = payload;
        },
        setCompany(state, company){
            state.company = company;
        },
        setContact(state, contact){
            state.contact = contact.contactSettings;
            state.id = contact.id
        },
        setCivilities(state, civilities) {
            state.civilities = civilities;
            state.contact.civility = civilities[0];
        },
        setCivility(state, civility) {
            state.contact.civility = civility;
        },
        setName(state, name) {
            state.contact.name = name;
        },
        setForename(state, forename) {
            state.contact.forename = forename;
        },
        setRole(state, role) {
            state.contact.role = role;
        },
        setIsLinkedContact(state, role) {
            state.contact.isLinkedContact = role;
        },
        setBirthdate(state, birthdate) {
            state.contact.birthdate = birthdate;
        },
        setEmail(state, email) {
            state.contact.email = email;
        },
        setPhone: (state, payload) => {
            state.contact.contactNumber.phoneNumber = payload;
        },
        setMobile: (state, payload) => {
            state.contact.contactNumber.mobileNumber = payload;
        },
        setFax: (state, payload) => {
            state.contact.contactNumber.faxNumber = payload;
        },
        setSocial(state, payload) {
            state.contact.paramsSettings.social = payload;
        },
        setFacebook(state, facebookURL) {
            state.contact.paramsSettings.social.facebook = facebookURL;
        },
        setTwitter(state, twitterURL) {
            state.contact.paramsSettings.social.twitter = twitterURL;
        },
        setLinkedin(state, linkedinURL) {
            state.contact.paramsSettings.social.linkedin = linkedinURL;
        },
        setId(state, id) {
            state.id = id;
        },
        setSmartTags(state, tags) {
            state.contact.smartTags = tags;
        },
        setNote: (state, payload) => {
            state.contact.paramsSettings.note = payload;
        },
        setSyncProviders: (state, payload) =>{
            state.contact.paramsSettings.syncProviders.mailchimp.isSetup = _.isNil(payload.find(sync => sync.value ===  "mailchimp")) ? false : true;
            state.contact.paramsSettings.syncProviders.mailjet.isSetup =  _.isNil(payload.find(sync => sync.value ===  "mailjet")) ? false : true;
            state.contact.paramsSettings.syncProviders.simplemail.isSetup =  _.isNil(payload.find(sync => sync.value ===  "simplemail")) ? false : true;
        },
        setSyncProvidersList: (state, payload) => {
            state.syncProvidersList = payload.filter(sync => !!sync.is_setup);
        },
        setMarketing: (state, payload) => {
            let marketingParams = [...state.contact.paramsSettings.marketing]
            marketingParams.map(marketing => marketing.value = false)
            
            for(let i = 0; i < payload.length; i++){
                let index = marketingParams.findIndex(marketing => marketing.code === payload[i].code);
                if (!_.isNil(index)){
                    marketingParams[index].value = !marketingParams[index].value;
                }
            }
        },
        setContactsList: (state, payload) =>{
            state.listing.contactsList = payload
        },
        resetForm(state) {
            state.contact = contactState();
        }
    },
    actions: {
        ...Third.actions,
        fetchMetadata: ({ dispatch, commit }) => {
            return new Promise((resolve, reject) => {
                ApiClient.get("/contacts/metadata", {}).then((res) => {
                    dispatch('commitMetaData', res);
                    resolve(res);
                }, err => {
                    reject(err);
                })
            })
        },

        fetchPendingStore:({commit}, store) =>{
            commit("setCompany", store.state.companySettings)
        },
        
        commitMetaData: ({ commit }, res) => {
            commit('setCivilities', res.data.civilities);
            const syncs = res.data.sync_providers?.length ? res.data.sync_providers : []; 
            commit('setSyncProvidersList', syncs)
            commit('setSyncProviders', syncs)
        },

        updateSmartTags: ({ commit }, tags) => {
            commit('setSmartTags', tags);
        },
        updateSyncProviders:({commit}, syncs) =>{
            commit("setSyncProviders", syncs)
        },
        /**
         * Reset current form
         * @param {} 
         */        
        clearThird: ({getters, commit}) => {
            commit('setForm', contactState())
            commit("clearCustomFields")
            commit('setCivility', getters.civilities[0]);
        },

        updateMarketing:({commit}, marketing)=>{
            commit("setMarketing", marketing)
        },

        updateThird: ({ state, commit, getters, dispatch }, action) => {
            return new Promise((resolve, reject) => {
                const contactUuid = uuidv4();
                let smartTags = getters.smartTags ? getters.smartTags : {};
                const datas = [
                    { "uri": "/contacts", "method": "POST", "uuid": contactUuid },
                    ContactApi.persistContact(state.contact),
                    { "uri": `/contacts/${contactUuid}/smart-tags`, "method": "POST"},
                    smartTags
                ];

                if(getters.customFields.length) {
                    datas.push({ "uri": `/contacts/${contactUuid}/custom-fields`, "method": "PUT" }),
                    datas.push(persistCustomFields(getters.customFields));
                }
                let ndjson = datas.map(JSON.stringify).join('\n')
                ApiBatchClient.post("/batch", {}, ndjson).then((res) => {
                    if (!res.data.error) {
                        commit("setId", res.data.responses[0].response.id);
                        if (action && action !== "") {
                            dispatch("clearThird")
                        }
                        Push.success(window.i18n.__('Contact ajouté avec succès'));
                        resolve({ id: res.data.responses[0].response.id, type: res.data.responses[0].response.type })
                    } else {
                        reject(res.data.responses[0]);
                    }
                }).catch(err => {
                    reject(err);
                });
            })

        }
    }
}